// extracted by mini-css-extract-plugin
export default {"facilityCategory":"facility_category_facilityCategory__CrFVi","facilityCategoryTitle":"facility_category_facilityCategoryTitle__QQ58X"};